// Approximate coordinates for map pins. City lookup first, then state centroid, then India center.
export const INDIA_CENTER = [22.9734, 78.6569];

export const STATE_COORDS = {
  "Andhra Pradesh": [15.9129, 79.74], "Arunachal Pradesh": [28.218, 94.7278],
  "Assam": [26.2006, 92.9376], "Bihar": [25.0961, 85.3131], "Chhattisgarh": [21.2787, 81.8661],
  "Goa": [15.2993, 74.124], "Gujarat": [22.2587, 71.1924], "Haryana": [29.0588, 76.0856],
  "Himachal Pradesh": [31.1048, 77.1734], "Jharkhand": [23.6102, 85.2799],
  "Karnataka": [15.3173, 75.7139], "Kerala": [10.8505, 76.2711], "Madhya Pradesh": [22.9734, 78.6569],
  "Maharashtra": [19.7515, 75.7139], "Manipur": [24.6637, 93.9063], "Meghalaya": [25.467, 91.3662],
  "Mizoram": [23.1645, 92.9376], "Nagaland": [26.1584, 94.5624], "Odisha": [20.9517, 85.0985],
  "Punjab": [31.1471, 75.3412], "Rajasthan": [27.0238, 74.2179], "Sikkim": [27.533, 88.5122],
  "Tamil Nadu": [11.1271, 78.6569], "Telangana": [18.1124, 79.0193], "Tripura": [23.9408, 91.9882],
  "Uttar Pradesh": [26.8467, 80.9462], "Uttarakhand": [30.0668, 79.0193], "West Bengal": [22.9868, 87.855],
  "Delhi": [28.7041, 77.1025], "Jammu and Kashmir": [33.7782, 76.5762], "Ladakh": [34.2996, 78.2932],
  "Puducherry": [11.9416, 79.8083], "Chandigarh": [30.7333, 76.7794],
  "Andaman and Nicobar Islands": [11.7401, 92.6586], "Dadra and Nagar Haveli": [20.1809, 73.0169],
  "Daman and Diu": [20.4283, 72.8397], "Lakshadweep": [10.5667, 72.6417],
};

export const CITY_COORDS = {
  "Bangalore": [12.9716, 77.5946], "Bangalore Urban": [12.9716, 77.5946], "Mumbai": [19.076, 72.8777],
  "Mumbai City": [18.9388, 72.8354], "Mumbai Suburban": [19.1, 72.85], "Hyderabad": [17.385, 78.4867],
  "Pune": [18.5204, 73.8567], "Gurgaon": [28.4595, 77.0266], "Chennai": [13.0827, 80.2707],
  "Kolkata": [22.5726, 88.3639], "Ahmedabad": [23.0225, 72.5714], "Jaipur": [26.9124, 75.7873],
  "Surat": [21.1702, 72.8311], "Lucknow": [26.8467, 80.9462], "Kanpur": [26.4499, 80.3319],
  "Nagpur": [21.1458, 79.0882], "Indore": [22.7196, 75.8577], "Bhopal": [23.2599, 77.4126],
  "Noida": [28.5355, 77.391], "Ghaziabad": [28.6692, 77.4538], "Kochi": [9.9312, 76.2673],
  "Ernakulam": [9.9816, 76.2999], "Coimbatore": [11.0168, 76.9558], "Visakhapatnam": [17.6868, 83.2185],
  "Chandigarh": [30.7333, 76.7794], "Thiruvananthapuram": [8.5241, 76.9366], "Mysore": [12.2958, 76.6394],
};

export const resolveCoords = (property) => {
  const base = CITY_COORDS[property.city] || STATE_COORDS[property.state] || INDIA_CENTER;
  // deterministic jitter based on id so pins don't fully overlap
  let h = 0;
  const s = property.id || property.title || "x";
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 10000;
  const jx = ((h % 100) - 50) / 900;
  const jy = ((Math.floor(h / 100) % 100) - 50) / 900;
  return [base[0] + jy, base[1] + jx];
};
